import dayjs from 'dayjs';
import { IComputeMathFunction } from './IComputeMathFunction';
import { dateDifferenceReminder } from './implementations/DateDifferenceReminder';

export const ComputeMathDateFunctions: IComputeMathFunction[] = [
  {
    name: 'differenza_giorni',
    description:
      'Restituisce il numero di giorni di differenza tra due date. (Data1, Data2)',
    arguments: [{ type: 'string' }, { type: 'string' }],
    returnType: 'number',
    signature: 'differenza_giorni(Data1: Data, Data2: Data): Numero',
    fn: MathJs =>
      MathJs.typed('differenza_giorni', {
        [`string, string`]: function (first: string, second: string) {
          const firstDate = dayjs(first);
          const secondDate = dayjs(second);
          return secondDate.diff(firstDate, 'day');
        },
      }),
  },
  {
    name: 'differenza_mesi',
    description:
      'Restituisce il numero di mesi di differenza tra due date. (Data1, Data2)',
    arguments: [{ type: 'string' }, { type: 'string' }],
    returnType: 'number',
    signature: 'differenza_giorni(Data1: Data, Data2: Data): Numero',
    fn: MathJs =>
      MathJs.typed('differenza_mesi', {
        [`string, string`]: function (first: string, second: string) {
          const firstDate = dayjs(first);
          const secondDate = dayjs(second);
          // Al momento su `resto_differenza_date` usiamo Luxon, che è più
          // affidabile.
          // Non c'è il problema su questa funzione, quindi possiamo usare dayjs,
          // ma in futuro possiamo valutare di rimuovere dayjs e usare solo Luxon.
          return secondDate.diff(firstDate, 'months');
        },
      }),
  },
  {
    name: 'resto_differenza_date',
    description:
      'Restituisce il resto della differenza tra due date alla precisione richiesta, che può essere impostata in "anni", "mesi", "giorni" o "ore". (Data1, Data2, Precisione). Gli intervalli sono considerati Inclusi, quindi dal 01/01 al 31/01 è un mese.',
    arguments: [{ type: 'string' }, { type: 'string' }, { type: 'string' }],
    returnType: 'number',
    signature:
      'resto_differenza_date(Data1: Data, Data2: Data, Precisione: Testo): Numero',
    fn: MathJs =>
      MathJs.typed('resto_differenza_date', {
        [`string, string, string`]: function (
          first: string,
          second: string,
          precision: string,
        ) {
          return dateDifferenceReminder(first, second, precision);
        },
      }),
  },
  /**
   * Controlla se un set di periodi temporali si sovrappongono.
   */
  {
    name: 'verifica_sovrapposizione_periodi',
    description: 'Verifica se un insieme di periodi temporali si sovrappone',
    arguments: [{ type: 'list' }, { type: 'string' }, { type: 'string' }],
    returnType: 'boolean',
    signature:
      'verifica_sovrapposizione_periodi(lista: Lista, dataDa: Stringa, dataA: Stringa): Booleano',
    fn: MathJs =>
      MathJs.typed('verifica_sovrapposizione_periodi', {
        [`Array, string, string`]: function (
          periodsList: Array<Record<string, any>>,
          startDateField: string,
          endDateField: string,
        ) {
          if (!periodsList || periodsList.length < 2) return false;

          try {
            const validPeriods = periodsList
              .filter(period => period[startDateField] && period[endDateField])
              .map(period => ({
                startDate: dayjs(period[startDateField]),
                endDate: dayjs(period[endDateField]),
              }))
              .filter(
                period =>
                  period.startDate.isValid() && period.endDate.isValid(),
              );

            for (let i = 0; i < validPeriods.length; i++) {
              for (let j = i + 1; j < validPeriods.length; j++) {
                const periodA = validPeriods[i];
                const periodB = validPeriods[j];

                const isOverlapping =
                  periodA.startDate.isBefore(periodB.endDate) &&
                  periodB.startDate.isBefore(periodA.endDate);

                if (isOverlapping) {
                  return true;
                }
              }
            }
          } catch (error) {
            return false;
          }

          return false;
        },
      }),
  },
];
